import { useState, useEffect } from 'react';
import FiberCompanyApi from '../../../../../../API/FiberCompanyApi';

const useFiberCompanies = (fiberCompanyId) => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      if (!fiberCompanyId) return;
      const req = {
        id: fiberCompanyId,
        hasOfferTemplate: true,
        pagingParams: { pageNumber: 1, pageSize: 100 },
      };
      const res = await FiberCompanyApi.SearchFiberCompany(req);
      if (res?.status?.success) {
        setCompanies(res.data.list);
      }
    };
    fetchCompanies();
  }, [fiberCompanyId]);

  return companies;
};

export default useFiberCompanies;
